module.exports = __webpack_public_path__ + "img/terminal_finder_mac.f38bbde0.png";